import React from 'react';
import PropTypes from 'prop-types';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import memoize from 'lodash.memoize';
import { set, collection } from 'utils/immutable';
import PermContactCalendar from '@mui/icons-material/PermContactCalendar';
import { loadMonthlyObligations, updateDocumentPartnerMonthlyObligations } from '../actionCreators';
import OfferPartnerMonthlyObligationsList from './OfferPartnerMonthlyObligationsList';
import { getOfferPartnerMonthlyObligations, getMonthlyObligationsIsLoaded } from '../selectors';
import { CollapseCard } from '@totalsoft/rocket-ui';

class OfferPartnerMonthlyObligationsContainer extends React.PureComponent {
  state = {
    expanded: false,
    editable: false,
    prevPropsPartnerMonthlyObligations: null,
    partnerMonthlyObligations: null,
    saving: false
  };

  static getDerivedStateFromProps(props, state) {
    if (props.partnerMonthlyObligations !== state.prevPartnerMonthlyObligations) {
      return {
        prevPartnerMonthlyObligations: props.partnerMonthlyObligations,
        partnerMonthlyObligations: props.partnerMonthlyObligations
      };
    }
    return null;
  }

  componentDidMount() {
    if (this.state.expanded) this.loadData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isLoaded !== this.props.isLoaded && !this.props.isLoaded) {
      this.loadData();
    }
  }

  loadData = async () => {
    const { actions, documentId, siteId, partnerId, isAssociatedPartner } = this.props;
    actions.loadMonthlyObligations(documentId, siteId, partnerId, isAssociatedPartner);
  };

  onCardToggle = (_, expanded) => {
    this.setState({ expanded: !expanded });
    if (!expanded) this.loadData();
  };

  onEdit = () => {
    this.setState({ editable: true });
  };

  changeItemProperty = memoize(index => (prop, value) => {
    this.setState(prevState => ({
      partnerMonthlyObligations: collection.update(index, set(prop, value), prevState.partnerMonthlyObligations)
    }));
  });

  save = async () => {
    this.setState({ saving: true });
    const { documentId, siteId, partnerId, isAssociatedPartner } = this.props;
    var data = {
      documentId,
      siteId,
      partnerId,
      values: this.state.partnerMonthlyObligations.map(x => ({
        value: x.value,
        partnerIncomeSourceDetailId: x.partnerIncomeSourceDetailId
      }))
    };

    try {
      const event = await this.props.actions.updateDocumentPartnerMonthlyObligations(data, isAssociatedPartner);
      this.setState({
        saving: false
      });

      if (event.ok) {
        this.setState({ editable: false });
      }
    } catch (error) {
      this.setState({ saving: false });
    }
  };

  render() {
    const { t } = this.props;
    const { expanded, editable, partnerMonthlyObligations, saving } = this.state;
    return (
      <CollapseCard
        id={'offerPartnerMonthlyObligationsCard'}
        icon={PermContactCalendar}
        title={t('OfferEdit.Client.MonthlyObligations.Title')}
        expanded={expanded}
        onToggle={this.onCardToggle}
        toggleOnHeaderClick
      >
        <OfferPartnerMonthlyObligationsList
          data={partnerMonthlyObligations}
          editable={editable}
          onEdit={this.onEdit}
          onSave={this.save}
          onPropertyItemChange={this.changeItemProperty}
          saving={saving}
        />
      </CollapseCard>
    );
  }
}

OfferPartnerMonthlyObligationsContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  partnerMonthlyObligations: PropTypes.array.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  offerHeader: PropTypes.object.isRequired,
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  partnerId: PropTypes.number.isRequired,
  isAssociatedPartner: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
  return {
    partnerMonthlyObligations: getOfferPartnerMonthlyObligations(state, ownProps.partnerId),
    isLoaded: getMonthlyObligationsIsLoaded(state, ownProps.partnerId),
    offerHeader: state.currentOffer.header
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ loadMonthlyObligations, updateDocumentPartnerMonthlyObligations }, dispatch),
    dispatch
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(OfferPartnerMonthlyObligationsContainer);
